import React, { forwardRef, useImperativeHandle, useState } from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MdOutlineCancel } from "react-icons/md";

import { Description, DescriptionWrapper, Warning } from "./styles";
import ConfirmationModal from "Components/Dialogs/ConfirmationModal";
import { Color } from "Components/Form/Button";
import { colors } from "@zapalacorp/tokens";

interface DeleteLogicModalProps {
  onDelete: () => void;
}

export interface DeleteLogicHandle {
  onOpenModal: () => void;
  onCloseModal: () => void;
}

export const ConfirmDeleteLogicModal = forwardRef<DeleteLogicHandle, DeleteLogicModalProps>(
  (props, ref) => {
    const { onDelete } = props;
    const { t: translate } = useTranslation();

    const [open, setOpen] = useState<boolean>(false);

    useImperativeHandle(ref, () => ({
      onOpenModal: () => setOpen(true),
      onCloseModal: () => setOpen(false),
    }));

    return (
      <ConfirmationModal
        open={open}
        closeModal={() => setOpen(false)}
        type="error"
        title={translate("deleteLogic")}
        leftIconTitle={<MdOutlineCancel color={colors.error500} size={20} />}
        customColorCancel={Color.TEXT_INFO}
        customColorSave={Color.ERROR}
        textCancel={translate("back")}
        textSubmit={translate("delete")}
        submit={() => onDelete()}
        width="520px !important"
      >
        <Grid container spacing={2} className="mt-2">
          <Grid item className="w-100">
            <DescriptionWrapper>
              <Description>{translate("areYouSureYouWantToDeleteThisLogic")}?</Description>

              <Warning className="error">
                {translate("thisActionIsPermanentAndCannotBeUndone")}
              </Warning>
            </DescriptionWrapper>
          </Grid>
        </Grid>
      </ConfirmationModal>
    );
  }
);
